import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../utility/Utility";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

export default function UpdateCompany() {
  const navigate = useNavigate();
  const location = useLocation();
  const companyData = location.state?.companyData;
  
  const [formData, setFormData] = useState({
    _id: companyData?._id || "",
    companyName: companyData?.name || "",
    description: companyData?.description || "",
    isActive: companyData?.status === "active" || true
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        companyId: formData._id,
        companyName: formData.companyName,
        description: formData.description,
        isActive: formData.isActive
      };

      const response = await postData('/api/company/update', payload);
      if (response?.success) {
        toast.success(response.message || "Company updated successfully!");
        navigate(-1);
      } else {
        throw new Error(response?.error || "Failed to update company");
      }
    } catch (error) {
      toast.error(error.message || "Error updating company");
      console.error("Update company error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={5000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 px-2 d-flex align-items-center justify-content-between">
            <div>
              <h4 className="mb-1">Insurance Company Management</h4>
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">Companies</li>
                <li className="breadcrumb-item active"> Update Insurance Company</li>
              </ol>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <i className="fas fa-arrow-left me-1"></i> Back
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h5 className="mb-4">Update Insurance Company</h5>

              <form onSubmit={handleSubmit}>
                <div className="mb-3 row">
                  <label htmlFor="companyName" className="col-sm-3 col-form-label">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      className="form-control"
                      placeholder="Enter official name of the insurance company"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3 row">
                  <label htmlFor="description" className="col-sm-3 col-form-label">
                    Description/About <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <textarea
                      id="description"
                      name="description"
                      className="form-control"
                      placeholder="Enter short company profile or description"
                      value={formData.description}
                      onChange={handleInputChange}
                      rows="4"
                      required
                    ></textarea>
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => navigate("/company-list")}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <CustomLoader loading={loading} />
                    ) : (
                      "Update Company"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}